import React from 'react';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../context/premiumReport';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../common';
import PriceBreakdownTable from './PriceBreakdownTable';

interface Props {
	premiumReportData: PremiumReportData;
}

const PriceBreakdown = (props: Props) => {
	const { premiumReport } = props.premiumReportData;

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Price Breakdown</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<PriceBreakdownTable premiumReport={premiumReport} />
			</StyledSectionContainer>
		</>
	);
};

export default withPremiumReportContext<Props>(PriceBreakdown);
